import React from 'react';
import { Typography } from 'kangarootime-ui';
import Room from './Room';
import './Room.css';
import RaisedContainer from '../../../components/RaisedContainer';

const RoomPhotoPercentages = ({ rooms, selectRoom }) => (
  <RaisedContainer>
    <div style={{ margin: 8 }}>
      <Typography type='header'>Classroom</Typography>
      <Typography type='subsectionHeader'>Percentage of children in classroom(s) who have had a photo taken today</Typography>
      <div className='roomPercentagesContainer'>
        { rooms.map(room => <Room key={room.roomId} room={room} selectRoom={selectRoom} />)}
      </div>
    </div>
  </RaisedContainer>
);

export default RoomPhotoPercentages;
